import React from 'react';
import Website from '../../assets/links/website.svg';
import Phone from '../../assets/links/phone.svg';
import Directions from '../../assets/links/directions.svg';
import styles from './infoicon.module.css';
export var InfoIcon = function (_a) {
    var name = _a.name, url = _a.url;
    return (React.createElement("div", { className: styles.iconContainer, onClick: function () { return window.open(url, '_blank'); } },
        name === 'Website' && React.createElement(Website, null),
        name === 'Phone' && React.createElement(Phone, null),
        name === 'Directions' && React.createElement(Directions, null),
        React.createElement("p", null, name)));
};
